(function() {
    'use strict';

    var userInfo = null;

    angular.module('GorillaBoy.Search')
    .factory('QuerySearchManager', [
        '$rootScope',
        '$translate',
        '$log',
        '$q',
        'OrganizationService',
        'AppConstants',
        'SortService',
        'SearchCommons',
        'AuthService',
        'MessageProvider',
        'MessageManager',
        'authenticatedUser',
        'searchQueryParser', //For details go to: /vendor/search-query-parser/search-query-parser.js
        QuerySearchManager
    ]);

    function QuerySearchManager ($rootScope, $translate, $log, $q, OrganizationService, AppConstants, SortService, SearchCommons, AuthService,
              MessageProvider, MessageManager, authenticatedUser, searchQueryParser) {

        // load user info in this context
        if (!userInfo) {
            userInfo = authenticatedUser.getUserInfo();
        }

        var querySearchManager = {};

        var KEYWORDS = {
              OWNED_BY:       "oby",
              MODIFIED_FROM:  "mfrom",
              MODIFIED_TO:    "mto",
              CREATED_FROM:   "cfrom",
              CREATED_TO:     "cto",
              CREATED_BY:     "cby",
              MODIFIED_BY:    "mby",
              SHARED_BY:      "sby",
              START_DATE:     "sdt",
              END_DATE:       "edt",
              FILE_TYPE:      "ftype",
              LOCATION:       "floc",
              SCOPE:          "sscp",
              SORT_BY:        "srt"
          },
          QUERY_KEYWORDS = {
                "oby":    {requestAttributesPromise: ownedbyRequestAttributesPromise},
                "mfrom":  {requestAttributesPromise: modifiedfromRequestAttributesPromise},
                "mto":    {requestAttributesPromise: modifiedtoRequestAttributesPromise},
                "cfrom":  {requestAttributesPromise: createdfromRequestAttributesPromise},
                "cto":    {requestAttributesPromise: createdtoRequestAttributesPromise},
                "cby":    {requestAttributesPromise: createdbyRequestAttributesPromise},
                "mby":    {requestAttributesPromise: modifiedbyRequestAttributesPromise},
                "sby":    {requestAttributesPromise: sharedbyRequestAttributesPromise},
                "sdt":    {requestAttributesPromise: startdateRequestAttributesPromise},
                "edt":    {requestAttributesPromise: enddateRequestAttributesPromise},
                "ftype":  {requestAttributesPromise: filetypeRequestAttributesPromise},
                "floc":   {requestAttributesPromise: locationRequestAttributesPromise},
                "sscp":   {requestAttributesPromise: scopeRequestAttributesPromise},
                "srt":    {requestAttributesPromise: sortbyRequestAttributesPromise}
            },
            TRANSLATED_KEYWORDS = {
              "oby": $translate.instant('SEARCH.KEYWORD.OWNED_BY'),
              "mfrom": $translate.instant('SEARCH.KEYWORD.MODIFIED_FROM'),
              "mto": $translate.instant('SEARCH.KEYWORD.MODIFIED_TO'),
              "cfrom": $translate.instant('SEARCH.KEYWORD.CREATED_FROM'),
              "cto": $translate.instant('SEARCH.KEYWORD.CREATED_TO'),
              "cby": $translate.instant('SEARCH.KEYWORD.CREATED_BY'),
              "mby": $translate.instant('SEARCH.KEYWORD.MODIFIED_BY'),
              "sby": $translate.instant('SEARCH.KEYWORD.SHARED_BY'),
              "sdt": $translate.instant('SEARCH.KEYWORD.START_DATE'),
              "edt": $translate.instant('SEARCH.KEYWORD.END_DATE'),
              "ftype": $translate.instant('SEARCH.KEYWORD.FILE_TYPE'),
              "floc": $translate.instant('SEARCH.KEYWORD.LOCATION'),
              "sscp": $translate.instant('SEARCH.KEYWORD.SCOPE'),
              "srt": $translate.instant('SEARCH.KEYWORD.SORT_BY')
            },
            SEARCH_TEXT_KEYWORDS = {
              "AND": $translate.instant('SEARCH.SEARCH_TEXT_KEYWORD.AND'),
              "OR":  $translate.instant('SEARCH.SEARCH_TEXT_KEYWORD.OR')
            },
            TERMS_KEYWORDS = {
              AND: "AND",
              OR: "OR"
            },
            DATE_FORMAT = 'yy-mm-dd',
            SEARCH_LOCATIONS = SearchCommons.SEARCH_LOCATIONS,
            SEARCH_FILE_TYPES = SearchCommons.SEARCH_FILE_TYPES,
            SEARCH_TIMES = SearchCommons.SEARCH_TIMES,
            SEARCH_SCOPES = SearchCommons.SEARCH_SCOPES,
            SEARCH_SORT_BY = SearchCommons.SEARCH_SORT_BY,
            SEARCH_FIXED_OPTIONS = SearchCommons.SEARCH_FIXED_OPTIONS,
            SEARCH_MIMES_TRANSLATIONS = SearchCommons.SEARCH_MIMES_TRANSLATIONS,

            SEARCH_LOCATIONS_EXCLUSIONS = ["all"],
            SEARCH_FILE_TYPES_EXCLUSIONS = ["all"],
            SEARCH_TIMES_EXCLUSIONS = ["all", "custom"],
            SEARCH_SCOPES_EXCLUSIONS = ["none"],

            DOUBLE_QUOTES_REGEX = /(["])(\\?.)*?\1/g,
            SINGLE_AND_DOUBLE_QUOTES_REGEX = /(["'])(\\?.)*?\1/g,
            ENDS_WITH_COMMA_REGEX = /,\s*$/,
            MULTIPLE_COMMAS_REGEX = /,{2,}/g,
            SIMPLE_QUOTES_REGEX = /[\"\']/g,

            INVALID_LIST = "Invalid list";

        querySearchManager.CONSTANTS = {
          KEYWORDS: KEYWORDS,
          DATE_FORMAT: DATE_FORMAT
        };

        // Create other constants derived from previous constant
        var TRANSLATION_TO_NORMAL_KEYWORDS_MAPPING = invertTranslatedKeywordsDict(TRANSLATED_KEYWORDS),
            FIXED_VALUES_LOCATION_MAPPING = createValuesMapping(SEARCH_LOCATIONS, SEARCH_LOCATIONS_EXCLUSIONS),
            FIXED_VALUES_FILE_TYPE_MAPPING = createValuesMapping(SEARCH_FILE_TYPES, SEARCH_FILE_TYPES_EXCLUSIONS),
            FIXED_VALUES_SCOPE_MAPPING = createValuesMapping(SEARCH_SCOPES, SEARCH_SCOPES_EXCLUSIONS),
            FIXED_VALUES_SORT_BY_MAPPING = createValuesMapping(SEARCH_SORT_BY, []);

        // Input:
        //  {
        //    "oby": "owned_by:",
        //    "sdt": "start_date:"
        //  }
        // Output:
        //  {
        //    "owned_by": "oby:",
        //    "start_date": "sdt:"
        //  }
        function invertTranslatedKeywordsDict(keywords){
            var dict = {};

            for (var key in keywords) {
                dict[getTranslatedKeyword(key)] = key + ":";
            }

            return dict;
        }

        // Gets the translated keyword without ':'
        function getTranslatedKeyword(keyword) {
            return TRANSLATED_KEYWORDS[keyword].replace(/:/g, "").trim();
        }

        // Creates a map of keyword's fixed values and how they are going
        // to be resolved at the moment of translating the query. Example:
        //    <my_docs, "MyDocs">
        //    <shared_with_me, "Shared with me">
        //    <shared_by_me, "Shared by me">
        // So when the query is:
        //    location:shared_with_me
        // Using the map, it will be translated into
        //    location:"Shared with me"
        function createValuesMapping(fixedValues, valuesExclusions) {
            var mapping = {};

            for (var key in fixedValues) {
                if(valuesExclusions.indexOf(key) > -1) {
                    continue;
                }

                mapping[key] = fixedValues[key].label;
            }

            return mapping;
        }

        // Normalize query in any language to a common language
        // Example (in english):
        //    start_date:2018-07-30 owned_by:testuser
        // will return
        //    sdt:2018-07-30 oby:testuser
        querySearchManager.toNormalQuery = function(translatedQuery) {

            var keywordsMapper = TRANSLATION_TO_NORMAL_KEYWORDS_MAPPING;
            var valuesMapper = {};
            valuesMapper[getTranslatedKeyword(KEYWORDS.LOCATION)] = _.invert(FIXED_VALUES_LOCATION_MAPPING);
            valuesMapper[getTranslatedKeyword(KEYWORDS.FILE_TYPE)] = _.invert(FIXED_VALUES_FILE_TYPE_MAPPING);
            valuesMapper[getTranslatedKeyword(KEYWORDS.SCOPE)] = _.invert(FIXED_VALUES_SCOPE_MAPPING);
            valuesMapper[getTranslatedKeyword(KEYWORDS.SORT_BY)] = _.invert(FIXED_VALUES_SORT_BY_MAPPING);

            var fixedValueRegexProvider = function(value) {
                return new RegExp("[']{0,1}" + value + "[']{0,1}","gi");
            };

            var valuesTransformation = function(keyword, value) {
                return value;
            };

            var searchTextTransform = function(text) {
                var transformedText = text;
                for (var key in SEARCH_TEXT_KEYWORDS) {
                    var translatedKey = SEARCH_TEXT_KEYWORDS[key].trim();
                    var translatedKeyRegex = new RegExp("\\s(" + translatedKey + ")\\s","g");
                    transformedText = transformedText.replace(translatedKeyRegex, " " + key + " ");
                    translatedKeyRegex = new RegExp("^" + translatedKey + "$","g");
                    transformedText = transformedText.replace(translatedKeyRegex, key);
                }

                return transformedText;
            };

            return transformQuery(translatedQuery, keywordsMapper, valuesMapper, fixedValueRegexProvider, valuesTransformation, searchTextTransform);
        };

        // Element(s) that match the regex are replaced by {n}
        // Input:
        //    query: "hi" "this" "is" a test
        //    regex: DOUBLE_QUOTES_REGEX
        // Output:
        // {
        //    formatString: {0} {1} {2} a test,
        //    item: {
        //        "{0}":"hi", "{1}":"this", "{2}":"is"
        //    }
        // }
        function createFormatString(query, regex) {
            var itemsMap = {},
                idx = 0;

            var formatStr = query.replace(regex, function(match) {
                var regexReplacement = "{" + (idx++) + "}";
                itemsMap[regexReplacement] = match;
                return regexReplacement;
            });

            return {
                formatString: formatStr,
                items: itemsMap
            };
        }

        // Formats a string using the result from createFormatString function
        // Input:
        //    str: {0} {1} {2} a test
        //    formatMap: {
        //        "{0}":"hi", "{1}":"this", "{2}":"is"
        //    }
        // Output:
        //    "hi" "this" "is" a test
        //
        function formatString(str, formatMap) {
            var replacementRegex = /\{(\d+)\}/g;

            return str.replace(replacementRegex, function(match) {
                return formatMap[match];
            });
        }

        // Replace the values of 'query' using 'keywordsMapper' and 'valuesMapper'. To identify what is going to be considered as a value,
        // 'valuesRegexProvider' is used for such purpose. If some modification are needed for the value, once it is identified, 'valuesTransformation'
        // is used. 'searchTextTransformation' is used to transform some values in the search term, for example AND, OR keywords.
        //
        // query - The query to be transformed
        // keywordsMapper - Map that contains the keywords to be transformed and the values that will replace them.
        // valuesMapper - Map that contains the keyword's values to be transformed and the  values that will replace them.
        // valuesRegexProvider - RegExp that helps to identify the keyword's values that are going to be altered by valuesMapper
        //                      (Since not all the keyword's values need to be transformed)
        // valuesTransformation - Function that allows to transform the values found by 'valuesRegexProvider'.
        //                        For example, if we want to enclose with quotes or directly return the value with transformations
        //                        (This is useful when the query is transform to other languages, since some values will have quotes and others won't)
        // searchTextTransformation - Function that allows to transform the values found as part of the search text. It is used to identify AND OR keywords
        //                            and translate them to proper languages.
        //
        // Example (translated query to normalized query):
        //      query:  start_date:2018-07-27 location:'Shared by me'  ResourceA AND ResourceB
        //      keywordsMapper:   <start_date, sdt>, <location floc>, ...
        //      valuesMapper: <Shared with me, shared_with_me>, <Microsoft Powerpoint, powerpoint>
        //      valuesRegexProvider:  RegExp("[']{0,1}" + value + "[']{0,1}","gi")    // RegExp for values enclose in single quotes
        //      valuesTransformation: { return value; }       // no transformation are needed,
        //                                                    (transformation are usually needed when going from normalized query to translated query)
        //      searchTextTransformation:  ...   // Code to identify AND OR keywords and translate them if needed.
        //  Returns:
        //      sdt:2018-07-27 floc:shared_by_me ResouceA AND ResourceB
        //
        function transformQuery(query, keywordsMapper, valuesMapper, valuesRegexProvider, valuesTransformation, searchTextTransformation) {

            if(!query) {
                return "";
            }

            // Extract words enclosed in double and single quotes. They will be ingored
            var formatResult = createFormatString(query, SINGLE_AND_DOUBLE_QUOTES_REGEX);
            var formattedQuery = formatResult.formatString;

            // Remove spaces before ':'. This is useful for French keywords which have an space before ':'
            formattedQuery = formattedQuery.replace(/\s*:/g, ":");

            var keywordsList = [];
            for (var keyword in keywordsMapper){
                keywordsList.push(keyword);
            }

            var options = {keywords: keywordsList};
            var parseResult = searchQueryParser.parse(formattedQuery, options);

            var newQuery = '';
            if (typeof parseResult === 'string') {
                newQuery = searchTextTransformation(parseResult);
            } else {

                var lastOffsetEnd = 0;
                for (var idx in parseResult.offsets) {
                    var offset = parseResult.offsets[idx];
                    var whitespaces = new Array(offset.offsetStart - lastOffsetEnd + 1).join(" ");
                    lastOffsetEnd = offset.offsetEnd;

                    if (offset.hasOwnProperty("text")) {
                        newQuery += whitespaces + searchTextTransformation(offset.text);

                    } else {

                      // Restore double and single quotes just for this value
                      var value = formatString(offset.value, formatResult.items);

                      // Remove double quotes values for this value. Keep single quotes
                      var valueFormatResult = createFormatString(value, DOUBLE_QUOTES_REGEX);
                      value = valueFormatResult.formatString;

                      if (valuesMapper.hasOwnProperty(offset.keyword)){

                          // Replaces fixed values using the given valuesMapper, valuesRegexProvider, valuesTransformation
                          var mappingValuesForKeyword = valuesMapper[offset.keyword];
                          for (var val in mappingValuesForKeyword){
                              var valueRegex = valuesRegexProvider(val);
                              value = value.replace(valueRegex, valuesTransformation(offset.keyword, mappingValuesForKeyword[val]));
                          }

                      }

                      //Restore double quotes for this value
                      value = formatString(value, valueFormatResult.items);
                      newQuery += whitespaces + keywordsMapper[offset.keyword] + value;
                    }
                }
            }

            // Restore any double quotes or single quotes missing
            newQuery = formatString(newQuery, formatResult.items);

            return newQuery;
        }

        // Translate a keywords and keywords'values (if needed) of a normalizedQuery
        // to browser's language
        // Example (in english):
        //    sdt:2018-07-30 oby:testuser
        // will return
        //    start_date:2018-07-30 owned_by:testuser
        querySearchManager.translateQuery = function(normalizedQuery) {

            var valuesMapper = {};
            valuesMapper[KEYWORDS.LOCATION] = FIXED_VALUES_LOCATION_MAPPING;
            valuesMapper[KEYWORDS.FILE_TYPE] = FIXED_VALUES_FILE_TYPE_MAPPING;
            valuesMapper[KEYWORDS.SCOPE] = FIXED_VALUES_SCOPE_MAPPING;
            valuesMapper[KEYWORDS.SORT_BY] = FIXED_VALUES_SORT_BY_MAPPING;
            valuesMapper[KEYWORDS.START_DATE] = {
                "today":  encloseInQuotes( $.datepicker.formatDate(DATE_FORMAT, querySearchManager.parseTimeValueToDate(SEARCH_FIXED_OPTIONS.TIMES.TODAY)) ),
                "7_days": encloseInQuotes( $.datepicker.formatDate(DATE_FORMAT, querySearchManager.parseTimeValueToDate(SEARCH_FIXED_OPTIONS.TIMES.SEVEN_DAYS)) ),
                "30_days": encloseInQuotes( $.datepicker.formatDate(DATE_FORMAT, querySearchManager.parseTimeValueToDate(SEARCH_FIXED_OPTIONS.TIMES.THIRTY_DAYS)) )
            };

            var keywordValueRegexProvider = function(value) {
                return new RegExp(value, "gi");
            };

            var fixedValuesTransformation = function(keyword, value) {
                if (keyword == KEYWORDS.START_DATE) {
                  return value;
                }
                return encloseInQuotes( value );
            };

            var searchTextTranslate = function(text) {
                var transformedText = text;
                for (var key in SEARCH_TEXT_KEYWORDS) {
                    var keyRegex = new RegExp("\\s(" + key + ")\\s","g");
                    transformedText = transformedText.replace(keyRegex, " " + SEARCH_TEXT_KEYWORDS[key].trim() + " ");
                    keyRegex = new RegExp("^" + key + "$","g");
                    transformedText = transformedText.replace(keyRegex, SEARCH_TEXT_KEYWORDS[key].trim());
                }

                return transformedText;
            };

            return transformQuery(normalizedQuery, TRANSLATED_KEYWORDS, valuesMapper, keywordValueRegexProvider, fixedValuesTransformation, searchTextTranslate);
        };

        // Parse fixed date value to a date object.
        // For example:
        // if urlValue is 7_days create a date object with a 7 days in past.
        // urlValue is the value given to date keywords (modified_from, start_date, etc.)
        // in url.
        querySearchManager.parseTimeValueToDate = function(urlValue) {

            if (urlValue == SEARCH_FIXED_OPTIONS.TIMES.TODAY) {

                var today = new Date();
                return today;

            } else if (urlValue == SEARCH_FIXED_OPTIONS.TIMES.SEVEN_DAYS) {
                var seven_days = new Date();
                seven_days.setDate(seven_days.getDate() - 7);
                return seven_days;

            } else if (urlValue == SEARCH_FIXED_OPTIONS.TIMES.THIRTY_DAYS) {
                var thirty_days = new Date();
                thirty_days.setDate(thirty_days.getDate() - 30);
                return thirty_days;
            }

            return querySearchManager.parseDate(urlValue);
        };

        // Since we can face some inconsistencies with timezones and supported
        // date formats by browsers. The preferred date format will be YYYY-MM-DD.
        querySearchManager.parseDate = function(strDate) {
            strDate = strDate.replace(SIMPLE_QUOTES_REGEX, "");
            var date;
            try{
                date = $.datepicker.parseDate(DATE_FORMAT, strDate);
            }catch(err){
                $log.error("Not supported date");
            }

            return date;
        };

        // Parse the query in common language to a map of <keyword, keyword value>
        querySearchManager.parseNormalizedQueryToKeywordsMap = function(normalizedQuery) {

            // Extract phrases enclosed in quotes. They will be ignored. Example:
            // "hello world!!" 'this is a test message' => {0} {1}
            var formatResult = createFormatString(normalizedQuery, SINGLE_AND_DOUBLE_QUOTES_REGEX);
            normalizedQuery = formatResult.formatString;

            var keywordsList = [];
            for (var key in QUERY_KEYWORDS) {
                keywordsList.push(key);
            }

            var options = {keywords: keywordsList};
            var parseResult = searchQueryParser.parse(normalizedQuery, options);
            var keywordsMap = {};

            if (typeof parseResult === 'string') {
                keywordsMap.search_text = parseResult;
            } else {
                // Construct search term text
                keywordsMap.search_text = '';
                for (var offsetIdx in parseResult.offsets){
                    var offsetObj = parseResult.offsets[offsetIdx];
                    if (offsetObj.hasOwnProperty("text") && !ignoreOffset(parseResult.offsets, parseInt(offsetIdx))) {
                        keywordsMap.search_text += offsetObj.text + " ";
                    }
                }
                keywordsMap.search_text = keywordsMap.search_text.trim();

                for (var idx in parseResult) {
                    if (idx != 'exclude' && idx != 'offsets' && idx != 'text') {
                        keywordsMap[idx] = (typeof parseResult[idx] === 'string')? parseResult[idx] : parseResult[idx].join(",");
                    }
                }
            }

            // Restore quotes values. Example:
            // {0} {1} => "hello world!" 'this is a test message'
            var quotesReplaceRegex = /\{(\d+)\}/g;
            for (var keyword in keywordsMap) {
                keywordsMap[keyword] = formatString(keywordsMap[keyword], formatResult.items);
            }

            // Adding empty keywords
            for (var i in parseResult.offsets) {
                var offset = parseResult.offsets[i];
                if (offset.hasOwnProperty("keyword") && !keywordsMap[offset.keyword]) {
                    keywordsMap[offset.keyword] = offset.value;
                }
            }

            return keywordsMap;
        };

        function encloseInQuotes(value) {
            return "'" + value + "'";
        }

        function ignoreOffset(offsetList, currentOffsetIdx) {
            var emptyKeywordObj = {keyword: "empty"};
            var currentOffset = offsetList[currentOffsetIdx],
                previousOffset = (currentOffsetIdx === 0)? emptyKeywordObj : offsetList[currentOffsetIdx - 1],
                nextOffset = (currentOffsetIdx === offsetList.length - 1)? emptyKeywordObj : offsetList[currentOffsetIdx + 1];

            // Ignore AND/OR when they are not between search terms
            if (currentOffset.hasOwnProperty("text") &&
                (currentOffset.text === TERMS_KEYWORDS.AND || currentOffset.text === TERMS_KEYWORDS.OR)) {

                return previousOffset.hasOwnProperty("keyword") || nextOffset.hasOwnProperty("keyword");
            }

            return false;
        }

        // create a query to give as URL to browser from a map of keywords.
        // Input:
        //    <"std" : "2018-07-24">
        //    <"floc" : "mydocs">
        //    <"oby" : "testuser">
        // Output:
        //    std:2018-07-24 floc:mydocs oby:testuser
        querySearchManager.createURLQueryFromKeywordsMap = function(keywordsMap) {
            var urlQuery = "";
            for (var key in keywordsMap) {
                urlQuery += key + ":" + keywordsMap[key] + " ";
            }

            return urlQuery.trim();
        };

        // Using a map of <keyword, keyword value>
        // Parses those values to attributes for SearchV2 Service.
        querySearchManager.getAdvanceOptionsPromise = function(paramsMap, keywordsOptionsValue){

            var deferred = [];

            for (var key in paramsMap) {

                var keyword = QUERY_KEYWORDS[key];
                if (keyword) {
                    deferred.push( keyword.requestAttributesPromise(paramsMap[key], keywordsOptionsValue) );
                } else {
                    delete paramsMap[key];
                    $log.info("Keyword " + key + " is not recognized");
                }
            }

            return $q.all(deferred);
        };

        function isValidList(queryList){
            return queryList && !ENDS_WITH_COMMA_REGEX.test(queryList) &&
                    !MULTIPLE_COMMAS_REGEX.test(queryList);
        }

        function searchOrganizationUserIds(userQuery){
            var searchUsersQuery = $rootScope.escapeHTML(userQuery),
                promises = [],
                done = $q.defer();

            if (!isValidList(userQuery)) {
                done.reject(INVALID_LIST);
            }

            //We can find for more than one user if they separated by commas
            var searchUsersTokens = searchUsersQuery.split(",");

            for (var i in searchUsersTokens) {
                var userToSearch = searchUsersTokens[i];
                if (userToSearch) {
                    userToSearch = userToSearch.replace(SIMPLE_QUOTES_REGEX, "");
                    promises.push( OrganizationService.searchOrganizationUsers({query: userToSearch, pageSize: 10}) );
                }
            }

            $q.all(promises).then(function (responses) {
                var usersId = [];

                for (var i in responses) {
                    var users = responses[i].data.Users;
                    for (var j in users){
                        usersId.push( users[j].Id );
                    }
                }

                done.resolve({UsersId: usersId});
            }, function (error) {
                done.reject(error);
            });

            return done.promise;
        }

        function getEpochTimestampFromStrDate(strDate, hour, minute, second){
            var date = querySearchManager.parseDate(strDate);
            if (date) {
              date.setHours(hour, minute, second);
            }

            return date? date.getTime()/1000 : Number.NaN;
        }

        function ownedbyRequestAttributesPromise(ownedbyQuery) {
            var deferred = $q.defer();

            searchOrganizationUserIds(ownedbyQuery)
            .then(function (response) {
                deferred.resolve({OwnerIds: response.UsersId});
            }, function (err){
                $log.error(err);
                // We use resolve() instead of reject(), since these
                // attributes are optional, so we don't want the execution
                // to be interrumpted
                if (err == INVALID_LIST) {
                    deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.OWNED_BY) );
                } else {
                    deferred.resolve({IncorrectValue: KEYWORDS.OWNED_BY});
                }
            });

            return deferred.promise;
        }

        function modifiedfromRequestAttributesPromise(modifiedfromQuery) {
            var modifiedFromTimestamp = getEpochTimestampFromStrDate(modifiedfromQuery, 0, 0, 0),
                deferred = $q.defer();

            if(isNaN(modifiedFromTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.MODIFIED_FROM) );
            } else {
                deferred.resolve({ModifiedTimestampRange_Start: modifiedFromTimestamp});
            }

            return deferred.promise;
        }

        function modifiedtoRequestAttributesPromise(modifiedtoQuery) {
            var modifiedToTimestamp = getEpochTimestampFromStrDate(modifiedtoQuery, 23, 59, 59),
                deferred = $q.defer();

            if(isNaN(modifiedToTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.MODIFIED_TO) );
            } else {
                deferred.resolve({ModifiedTimestampRange_End: modifiedToTimestamp});
            }

            return deferred.promise;
        }

        function createdfromRequestAttributesPromise(createdfromQuery) {
            var createdFromTimestamp = getEpochTimestampFromStrDate(createdfromQuery, 0, 0, 0),
                deferred = $q.defer();

            if(isNaN(createdFromTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.CREATED_FROM) );
            } else {
                deferred.resolve({CreatedTimestampRange_Start: createdFromTimestamp});
            }

            return deferred.promise;
        }

        function createdtoRequestAttributesPromise(createdtoQuery) {
            var createdToTimestamp = getEpochTimestampFromStrDate(createdtoQuery, 23, 59, 59),
                deferred = $q.defer();

            if(isNaN(createdToTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.CREATED_TO) );
            } else {
                deferred.resolve({CreatedTimestampRange_End: createdToTimestamp});
            }

            return deferred.promise;
        }

        function createdbyRequestAttributesPromise(createdbyQuery) {
            var deferred = $q.defer();

            searchOrganizationUserIds(createdbyQuery)
            .then(function(response) {
                deferred.resolve({CreatorIds: response.UsersId});
            }, function (err) {
                $log.error(err);

                if (err == INVALID_LIST) {
                    deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.CREATED_BY) );
                } else {
                    deferred.resolve({IncorrectValue: KEYWORDS.CREATED_BY});
                }
            });

            return deferred.promise;
        }

        function modifiedbyRequestAttributesPromise(modifiedbyQuery) {
            var deferred = $q.defer();

            searchOrganizationUserIds(modifiedbyQuery)
            .then(function (response) {
                deferred.resolve({ModifierIds: response.UsersId});
            }, function (err) {
                $log.error(err);

                if (err == INVALID_LIST) {
                    deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.MODIFIED_BY) );
                } else {
                    deferred.resolve({IncorrectValue: KEYWORDS.MODIFIED_BY});
                }
            });

            return deferred.promise;
        }

        function sharedbyRequestAttributesPromise(sharedbyQuery) {
            var deferred = $q.defer();

            searchOrganizationUserIds(sharedbyQuery)
            .then(function (response) {
                deferred.resolve({SharedbyIds: response.UsersId});
            }, function (err) {
                $log.error(err);

                if (err == INVALID_LIST) {
                    deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.SHARED_BY) );
                } else {
                    deferred.resolve({IncorrectValue: KEYWORDS.SHARED_BY});
                }
            });

            return deferred.promise;
        }

        function startdateRequestAttributesPromise(startdateQuery) {
            var startDateTimestamp,
                deferred = $q.defer();

            if (startdateQuery == SEARCH_FIXED_OPTIONS.TIMES.TODAY) {
                var today = new Date();
                today.setHours(0,0,0,0);
                startDateTimestamp = today.getTime() / 1000;

            } else if (startdateQuery == SEARCH_FIXED_OPTIONS.TIMES.SEVEN_DAYS) {
                var seven_days = new Date();
                seven_days.setDate(seven_days.getDate() - 7);
                startDateTimestamp = seven_days.getTime() / 1000;

            } else if (startdateQuery == SEARCH_FIXED_OPTIONS.TIMES.THIRTY_DAYS) {
                var thirty_days = new Date();
                thirty_days.setDate(thirty_days.getDate() - 30);
                startDateTimestamp = thirty_days.getTime() / 1000;

            } else {
               startDateTimestamp = getEpochTimestampFromStrDate(startdateQuery, 0, 0, 0);
            }

            if(isNaN(startDateTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.START_DATE) );
            } else {
                deferred.resolve({ModifiedTimestampRange_Start: startDateTimestamp,
                                  CreatedTimestampRange_Start: startDateTimestamp});
            }

            return deferred.promise;
        }

        function enddateRequestAttributesPromise(enddateQuery) {
            var endDateTimestamp = getEpochTimestampFromStrDate(enddateQuery, 23, 59, 59),
                deferred = $q.defer();

            if(isNaN(endDateTimestamp)) {
                deferred.resolve( createIncorrectDateFormatDeferredResponse(KEYWORDS.END_DATE) );
            } else {
                deferred.resolve({ModifiedTimestampRange_End: endDateTimestamp,
                                  CreatedTimestampRange_End: endDateTimestamp});
            }

            return deferred.promise;
        }

        function getMimes(filetypeQuery) {

            var mime = {
                  list: [],
                  unknownExt: []
                },
                filetypeQueryLowerCase = filetypeQuery.trim().replace(/[\.\*\"\']/g, "").toLowerCase();

            var filetypeList = filetypeQueryLowerCase.split(",");
            for (var idx in filetypeList) {
                var filetype = filetypeList[idx];
                if (SEARCH_MIMES_TRANSLATIONS[filetype]) {
                    mime.list = mime.list.concat(SEARCH_MIMES_TRANSLATIONS[filetype]);
                } else {
                    mime.unknownExt = mime.unknownExt.concat(filetype);
                }
            }

            return mime;
        }

        function filetypeRequestAttributesPromise(filetypeQuery) {
            var deferred = $q.defer();

            if (filetypeQuery == SEARCH_FIXED_OPTIONS.FILE_TYPES.FOLDERS) {
                deferred.resolve({Types: ["FOLDER"]});

            } else if (filetypeQuery == SEARCH_FIXED_OPTIONS.FILE_TYPES.FILES) {
                deferred.resolve({Types: ["DOCUMENT"]});

            } else {

                if (!isValidList(filetypeQuery)) {
                    deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.FILE_TYPE) );

                } else {

                    var mimes = getMimes(filetypeQuery);
                    var deferredResponse = {};
                    if (mimes.list.length > 0) {
                        deferredResponse.ContentMimeTypes = mimes.list;
                    }
                    var foldersValueIdx = _.indexOf(mimes.unknownExt, SEARCH_FIXED_OPTIONS.FILE_TYPES.FOLDERS);
                    var filesValueIdx = _.indexOf(mimes.unknownExt, SEARCH_FIXED_OPTIONS.FILE_TYPES.FILES);
                    if (foldersValueIdx >= 0 || filesValueIdx >= 0) {
                        deferredResponse.IncorrectValue = KEYWORDS.FILE_TYPE;
                        deferredResponse.IncorrectHelperMessage = $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.FOLDERS_FILES_CANNOT_BE_LIST',{
                            folderTranslation: SEARCH_FILE_TYPES.folders.label,
                            filesTranslation: SEARCH_FILE_TYPES.files.label
                        });

                    } else if (mimes.unknownExt.length > 0) {
                        deferredResponse.IncorrectValue = KEYWORDS.FILE_TYPE;
                        deferredResponse.IncorrectHelperMessage = $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.UNKNOWN_FILETYPES', {
                            file_types: mimes.unknownExt.join(",")
                        });
                    }

                    deferred.resolve(deferredResponse);
                }
            }

            return deferred.promise;
        }

        function locationRequestAttributesPromise(locationQuery, locationOptionsValue) {
            var deferred = $q.defer();

            if (!isValidList(locationQuery)) {
                deferred.resolve( createInvalidListDeferredResponse(KEYWORDS.LOCATION) );
            }

            if (locationQuery == SEARCH_FIXED_OPTIONS.LOCATIONS.MY_DOCS) {
                deferred.resolve({AncestorIds: [userInfo.RootFolderId]});

            } else if (locationQuery == SEARCH_FIXED_OPTIONS.LOCATIONS.SHARED_WITH_ME) {
                deferred.resolve({SharedWithMe: true});

            } else if (locationQuery == SEARCH_FIXED_OPTIONS.LOCATIONS.SHARED_BY_ME) {
                deferred.resolve({SharedByMe: true});

            } else if (locationQuery == SEARCH_FIXED_OPTIONS.LOCATIONS.CURRENT_FOLDER && locationOptionsValue[KEYWORDS.LOCATION]){
                deferred.resolve({AncestorIds: [locationOptionsValue[KEYWORDS.LOCATION]]});

            } else {
                deferred.resolve( createMultipleValuesNotAllowedDeferredResponse(KEYWORDS.LOCATION, locationQuery) );

            }

            return deferred.promise;
        }

        function scopeRequestAttributesPromise(scopeQuery) {
            var deferred = $q.defer(),
                options = {},
                scopeList = scopeQuery.split(",");

            for(var idx in scopeList) {
              switch(scopeList[idx]){
                  case SEARCH_FIXED_OPTIONS.SCOPE.NAME:
                      options.SearchInName = true;
                      break;
                  case SEARCH_FIXED_OPTIONS.SCOPE.CONTENT:
                      options.SearchInContent = true;
                      break;
                  case SEARCH_FIXED_OPTIONS.SCOPE.COMMENTS:
                      options.SearchInComments = true;
                      break;
                  case SEARCH_FIXED_OPTIONS.SCOPE.LABELS:
                      options.SearchInLabels = true;
                      break;
                  default:
                      deferred.resolve( createInvalidValueDeferredResponse(KEYWORDS.SCOPE, scopeList[idx]) );
              }
            }

            if (!$rootScope.isContentSearchEnabled && (options.SearchInContent || options.SearchInComments)) {
                var scopeIncorrectValue = [];
                if(options.SearchInContent) {
                    scopeIncorrectValue.push("'" + SEARCH_SCOPES[SEARCH_FIXED_OPTIONS.SCOPE.CONTENT].label + "'");
                }
                if(options.SearchInComments) {
                    scopeIncorrectValue.push("'" + SEARCH_SCOPES[SEARCH_FIXED_OPTIONS.SCOPE.COMMENTS].label + "'");
                }
                deferred.resolve( createInvalidValueDeferredResponse(KEYWORDS.SCOPE, scopeIncorrectValue.join(",")) );

            } else if (Object.keys(options).length > 0) {
                deferred.resolve(options);

            } else {
                deferred.resolve( createInvalidValueDeferredResponse(KEYWORDS.SCOPE, scopeQuery) );
            }

            return deferred.promise;
        }

        function createInvalidValueDeferredResponse(keyword, invalidValue) {
            return  {IncorrectValue: keyword,
                     IncorrectHelperMessage: $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.INVALID_VALUE', {
                          value: invalidValue
                      })
                    };
        }

        function createInvalidListDeferredResponse(keyword) {
            return  {IncorrectValue: keyword,
                     IncorrectHelperMessage: $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.INVALID_LIST')
                    };
        }

        function createIncorrectDateFormatDeferredResponse(keyword) {
            return  {IncorrectValue: keyword,
                     IncorrectHelperMessage: $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.INCORRECT_DATE_FORMAT')
                    };
        }

        function createMultipleValuesNotAllowedDeferredResponse(keyword) {
            return  {IncorrectValue: keyword,
                   IncorrectHelperMessage: $translate.instant('SEARCH.KEYWORD.ERROR_MESSAGE.MULTI_NOT_ALLOWED')
                  };
        }

        // Maps the responses of promise methods above (e.g.: createdtoRequestAttributesPromise,
        // modifiedbyRequestAttributesPromise, etc) to the attributes in the Request
        // of SearchV2 Service.
        querySearchManager.mapAdvanceOptionsResponsesToRequest = function(responses) {

            // The attributes of this object need to be named in the same way as
            // the attributes listed in SearchV2Service for advanceOptions
            var advanceOptions = {},
                incorrectOptions = "",
                translatedKeywords = TRANSLATED_KEYWORDS;

            for (var i in responses) {
                var response = responses[i];

                // Map response of ownedbyRequestAttributesPromise
                if (response.hasOwnProperty("OwnerIds")) {
                    if (advanceOptions.OwnerIds) {
                        advanceOptions.OwnerIds =
                            advanceOptions.OwnerIds.concat( response.OwnerIds );
                    } else {
                        advanceOptions.OwnerIds = response.OwnerIds;
                    }
                }

                // Map response of modifiedfromRequestAttributesPromise
                if (response.hasOwnProperty("ModifiedTimestampRange_Start")) {
                    if (advanceOptions.ModifiedTimestampRange){
                        advanceOptions.ModifiedTimestampRange.Start =
                            response.ModifiedTimestampRange_Start;
                    } else {
                        advanceOptions.ModifiedTimestampRange =
                            {Start: response.ModifiedTimestampRange_Start};
                    }
                }

                // Map response of modifiedtoRequestAttributesPromise
                if (response.hasOwnProperty("ModifiedTimestampRange_End")) {
                    if (advanceOptions.ModifiedTimestampRange){
                        advanceOptions.ModifiedTimestampRange.End =
                            response.ModifiedTimestampRange_End;
                    } else {
                        advanceOptions.ModifiedTimestampRange =
                            {End: response.ModifiedTimestampRange_End};
                    }
                }

                // Map response of createdfromRequestAttributesPromise
                if (response.hasOwnProperty("CreatedTimestampRange_Start")) {
                    if (advanceOptions.CreatedTimestampRange){
                        advanceOptions.CreatedTimestampRange.Start =
                            response.CreatedTimestampRange_Start;
                    } else {
                        advanceOptions.CreatedTimestampRange =
                            {Start: response.CreatedTimestampRange_Start};
                    }
                }

                // Map response of createdtoRequestAttributesPromise
                if (response.hasOwnProperty("CreatedTimestampRange_End")) {
                    if (advanceOptions.CreatedTimestampRange){
                        advanceOptions.CreatedTimestampRange.End =
                            response.CreatedTimestampRange_End;
                    } else {
                        advanceOptions.CreatedTimestampRange =
                            {End: response.CreatedTimestampRange_End};
                    }
                }

                // Map response of createdbyRequestAttributesPromise
                if (response.hasOwnProperty("CreatorIds")) {
                    if (advanceOptions.CreatorIds) {
                        advanceOptions.CreatorIds =
                            advanceOptions.CreatorIds.concat( response.CreatorIds );
                    } else {
                        advanceOptions.CreatorIds = response.CreatorIds;
                    }
                }

                // Map response of modifiedbyRequestAttributesPromise
                if (response.hasOwnProperty("ModifierIds")) {
                    if (advanceOptions.ModifierIds) {
                        advanceOptions.ModifierIds =
                            advanceOptions.ModifierIds.concat( response.ModifierIds );
                    } else {
                        advanceOptions.ModifierIds = response.ModifierIds;
                    }
                }

                // Map response of sharedbyRequestAttributesPromise
                // shared_by is mapped to OwnerIds
                if (response.hasOwnProperty("SharedbyIds")) {
                    if (advanceOptions.OwnerIds) {
                        advanceOptions.OwnerIds =
                            advanceOptions.OwnerIds.concat( response.SharedbyIds );
                    } else {
                        advanceOptions.OwnerIds = response.SharedbyIds;
                    }
                }

                // Map response of filetypeRequestAttributesPromise
                // file_type is mapped to Types or ContentTypes
                if (response.hasOwnProperty("Types")) {
                    advanceOptions.Types = response.Types;

                } else if (response.hasOwnProperty("ContentMimeTypes")) {
                    advanceOptions.ContentMimeTypes = response.ContentMimeTypes;
                }

                // Map response of locationRequestAttributesPromise
                // location is mapped to AncestorIds, SharedWithMe, SharedByMe
                if (response.hasOwnProperty("SharedWithMe")) {
                    advanceOptions.SharedWithMe = true;

                } else if (response.hasOwnProperty("SharedByMe")) {
                    advanceOptions.SharedByMe = true;

                } else if (response.hasOwnProperty("AncestorIds")) {
                    advanceOptions.AncestorIds = response.AncestorIds;
                }

                // Map response of scopeRequestAttributesPromise
                // scope is mapped to SearchInName, SearchInContent, SearchInComments, SearchInLabels
                if (response.hasOwnProperty("SearchInLabels")) {
                    advanceOptions.SearchInLabels = true;
                }
                if (response.hasOwnProperty("SearchInName")) {
                        advanceOptions.SearchInName = true;
                }
                if (response.hasOwnProperty("SearchInContent")) {
                        advanceOptions.SearchInContent = true;
                }
                if (response.hasOwnProperty("SearchInComments")) {
                        advanceOptions.SearchInComments = true;
                }

                // TextLocale will be browser's language
                var language = window.determinePreferredLanguage();
                language = (language && language.length > 2)? language.substring(0,2) : language;
                advanceOptions.TextLocale = language;

                // Handle incorrect values response
                if (response.hasOwnProperty("IncorrectValue")) {
                    var key = response.IncorrectValue;
                    var keyword = translatedKeywords[key].slice(0, -1);

                    if (response.hasOwnProperty("IncorrectHelperMessage")) {
                        keyword += " (" + response.IncorrectHelperMessage + ")";
                    }

                    incorrectOptions = incorrectOptions.concat(keyword).concat(", ");
                }
            }

            // show incorrect values message for all keywords
            // including SORT_BY
            if (incorrectOptions) {
                incorrectOptions = incorrectOptions.slice(0, -2);
                var incorrectKeywords = MessageProvider.searchKeywordsValuesInvalid(incorrectOptions);
                MessageManager.addErrorMessage(incorrectKeywords);
            }

            return advanceOptions;
        };

        function sortbyRequestAttributesPromise(sortbyQuery) {
            var deferred = $q.defer(),
                sortServiceOptions = SortService.getDefaultSortOptions(AppConstants.ViewTypes.SEARCH_TYPE),
                sortOption;

            switch(sortbyQuery) {
                case SEARCH_FIXED_OPTIONS.SORT_BY.RELEVANCE:
                    sortOption = sortServiceOptions[4];
                    break;
                case SEARCH_FIXED_OPTIONS.SORT_BY.NAME:
                    sortOption = sortServiceOptions[1];
                    break;
                case SEARCH_FIXED_OPTIONS.SORT_BY.MODIFIED_DATE:
                    sortOption = sortServiceOptions[0];
                    break;
                case SEARCH_FIXED_OPTIONS.SORT_BY.SIZE:
                    sortOption = sortServiceOptions[2];
                    break;
                case SEARCH_FIXED_OPTIONS.SORT_BY.TYPE:
                    sortOption = sortServiceOptions[3];
                    break;
            }

            if (sortOption) {
              deferred.resolve({SortBy: sortOption});
            } else {
              deferred.resolve( createInvalidValueDeferredResponse(KEYWORDS.SORT_BY, sortOption) );
            }

            return deferred.promise;
        }

        // Maps the response of sortbyRequestAttributesPromise
        // to the sort attributes in the Request
        // of SearchV2 Service.
        querySearchManager.mapSortOptionResponsesToRequest = function(responses) {
            var sortOption;

            for (var i in responses) {
                var response = responses[i];

                if (response.hasOwnProperty("SortBy")) {
                    sortOption = response.SortBy;
                }
            }

            return sortOption;
        };

        return querySearchManager;
    }

}());
